var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "address-text", attrs: { "aria-busy": _vm.loading } },
    [
      _vm._v(" " + _vm._s(_vm.displayAddress) + " "),
      _vm.errorMessage
        ? _c(
            "small",
            { staticClass: "address-error", attrs: { role: "alert" } },
            [
              _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
              _vm.retryable
                ? _c(
                    "button",
                    { attrs: { type: "button" }, on: { click: _vm.load } },
                    [_vm._v(_vm._s(_vm.$t("sensitiveView.retry")))]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }